import { Injectable } from '@angular/core';
import { API_METHODS, API_URL } from 'common/constants/sm-constants';
import { GridPostParams } from 'common/models/utility-models/list-utility.model';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { SystemService } from 'common/services/core-services/system.service';
import { environment } from 'src/environments/environment';
import { GridDataService } from '../../base-data-services/grid-data.service';

import { NotificationModel } from 'common/models/page-models/notification/notification-data.model';
import { NotificationGridParams, NotificationListingModel } from 'common/models/page-models/notification/notification-grid.model';
import { DatePipe } from '@angular/common';


@Injectable({
    providedIn: 'root'
})
export class NotificationGridDataService extends GridDataService<NotificationListingModel, NotificationModel> {

    constructor(http: SmApiService, protected override ss: SystemService, protected datePipe: DatePipe) {
        super(API_URL.getNotificationList, http, ss);
    }

    override getEditUrlAndMethod(id) {
        const edit = {
            url: environment.apiUrl + API_URL.getAnnouncementDetailsById + '/' + id.id,
            method: API_METHODS.get
        }
        return edit;
    }

    override getGridParams(param): GridPostParams {
        return new NotificationGridParams();
    }

    getDeleteUrl() {
        return environment.apiUrl + API_URL.deleteNotification;
    }

    createInstance(): NotificationListingModel {
        return new NotificationListingModel();
    }

    override getDeletePayload(data) {
        let payload: any;
        if (data.id) {
            payload = { id: data.id }
        }
        else {
            payload = data;
        }
        return payload;
    }

    // override transformDataModel(data: any[], param) {
    //     super.transformDataModel(data, param);
    //     this.setSystemServiceData('name', API_URL.emailList, new NotificationGridParams(), 'detail');
    //     this.setSystemServiceData('batch_number', API_URL.batchList, new NotificationGridParams(), 'detail');
    //     this.setSystemServiceData('department_name', API_URL.branchList, new NotificationGridParams(), 'detail');
    //     this.setSystemServiceData('zone_name', API_URL.zoneList, new NotificationGridParams(), 'detail');
    //     this.setSystemServiceData('students', API_URL.studentsGrid, ' ', 'detail');

    //     return data;
    // }

    // override transformDataModel(apiRes: any, param) {
    //     super.transformDataModel(apiRes, param);
    //     apiRes[param].forEach(element => {
    //         element.display_datetime = this.datePipe.transform(element.display_datetime, 'dd-MM-yyyy h:mm a', 'UTC');
    //         console.log(element, 'ele');
    //         if (typeof element.student === "string") {
    //             let arr = element.student.split(',');
    //             if(arr.length > 10){
    //                 element.student = arr.slice(0,10).join(",") + "..."
    //             }
    //             console.log(arr);
    //         }
    //     });
    //     return apiRes;
    // }

    override transformDataModel(apiRes: any, param) {
        super.transformDataModel(apiRes, param);
        apiRes[param].forEach(element => {
            // Format the display_datetime field
            // element.display_datetime = this.datePipe.transform(
            //     element.display_datetime, 
            //     'dd-MM-yyyy h:mm a', 
            //     'UTC'
            // );

            const dateValue = element.display_datetime;
            if (dateValue instanceof Date) {
                element.display_datetime = dateValue;
            } else if (!isNaN(Date.parse(dateValue))) {
                element.display_datetime = this.datePipe.transform(
                    new Date(dateValue),
                    'dd-MM-yyyy h:mm a',
                    'UTC'
                );
            } else {
                element.display_datetime = dateValue;
            }

            if(element.send_to_all == 1){
                element.sendTo = "All";
                element.student_name = "";
            } else if(element.send_to_all == 2){
                element.sendTo = "Student";
                element.student_name = element.student;
            } else if(element.send_to_all == 3){
                element.sendTo = "Group";
                element.student_name = "";
            }
            // console.log(element, 'ele');
            
            // Handle student names if it's a string
            if (typeof element.student === "string") {
                let arr = element.student.split(',');
    
                if (arr.length > 5) {
                    // Show first 5 students and the count of remaining
                    element.student = arr.slice(0, 5).join(", ") + ` + ${arr.length - 5} more`;
                } else {
                    // If less than or equal to 5, display all names
                    element.student = arr.join(", ");
                }
    
                // console.log(arr);
            }
        });
        return apiRes;
    }


}
